var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"presentation-item-list"},_vm._l((_vm.presentationsList),function(p){return _c('presentation-item',{key:p,staticClass:"presentation-item",attrs:{"presentationID":p}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }